import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import APIHandler from 'config/APIHandler';
import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

export default class AddFavorite extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: false,
      favorited: false,
      allFavorites: {},
    };

    this.addRemoveHandler = this.addRemoveHandler.bind(this);
  }

  componentWillMount() {
    StorageHandler.exists(storageKeys.user).then((res) => res && this.setState({ user: true }));
    StorageHandler.load(storageKeys.favorites).then((favorites) => this.setState({ allFavorites: favorites }));

    this.getToggleInfo();
  }

  getToggleInfo() {
    const { upID, pageID, appId, viewType, favorites } = this.props;

    let newId = upID.toString();
    if (viewType === 'p') {
      newId = upID.slice(pageID.length);
    }
    if (favorites.data !== undefined && favorites.data.length > 0) {
      this.setToggled(favorites.data, newId);
    } else {
      StorageHandler.load(storageKeys.favorites).then((fav) => {
        if (fav !== false) {
          this.setToggled(fav.data, newId);
        } else {
          StorageHandler.load(storageKeys.user).then((userObj) => {
            if (userObj) {
              const { email } = userObj; // NOTE: Potentially undefined, not sure why
              APIHandler.getFavorite(appId, email).then((res) => {
                StorageHandler.save(storageKeys.favorites, res);
                this.setState({ allFavorites: res });
                this.getToggleInfo();
              });
            }
          });
        }
      });
    }
  }

  setToggled(favorites, upID) {
    favorites.forEach((data) => {
      if (data.unid === upID) {
        this.setState({ favorited: true });
      }
    });
  }

  addRemoveHandler() {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      const { email } = userObj;
      const { allFavorites } = this.state;

      const { appId, viewType, upID, pageID, title, url } = this.props;

      const params = {
        app_id: appId,
        type: viewType,
        unid: upID.toString(),
        email,
      };

      if (params.type === 'p') {
        params.unid = params.unid.slice(pageID.length);
      }

      APIHandler.trackEvent(appId, email, 'favorite', title, url, title).then(() => {});

      APIHandler.addFavorite(params).then((res) => {
        if (res.response !== undefined && res.response.status === 422) {
          allFavorites.data.forEach((favorite, i) => {
            if (favorite.unid === upID) {
              delete allFavorites.data[i];
            }
          });
          allFavorites.data = allFavorites.data.filter((fav) => fav !== null);
          APIHandler.removeFavorite(params).then(() => {
            this.setState({ favorited: false, allFavorites });
          });
        } else allFavorites.data.push(res.data);

        StorageHandler.save(storageKeys.favorites, allFavorites);
        this.setState({ favorited: true, allFavorites });
      });
    });
  }

  render() {
    const { user, favorited } = this.state;
    const { bgEnabled, centered, avoidVideoControls, color } = this.props;
    return (
      user && (
        <div
          className={`addFavorite__container
          ${centered && 'centered'}
          ${avoidVideoControls && 'avoidVideoControls'}`}
        >
          <div
            className={`addFavorite__background ${bgEnabled && 'bgEnabled'} ${color && 'colored'}`}
            onClick={this.addRemoveHandler}
            onKeyDown={this.addRemoveHandler}
            role="button"
            tabIndex={0}
          >
            {favorited ? <FontAwesomeIcon icon={['fas', 'heart']} /> : <FontAwesomeIcon icon={['far', 'heart']} />}
          </div>
        </div>
      )
    );
  }
}

AddFavorite.propTypes = {
  appId: PropTypes.number.isRequired,
  viewType: PropTypes.string.isRequired,
  upID: PropTypes.string.isRequired,
  bgEnabled: PropTypes.bool,
  favorites: PropTypes.shape(),
  centered: PropTypes.bool,
  avoidVideoControls: PropTypes.bool,
  pageID: PropTypes.string,
  color: PropTypes.bool,
  title: PropTypes.string,
  url: PropTypes.string,
};

AddFavorite.defaultProps = {
  bgEnabled: false,
  centered: false,
  favorites: {},
  avoidVideoControls: false,
  pageID: '',
  color: false,
  title: '',
  url: '',
};
